import { createFileRoute, redirect } from '@tanstack/react-router';

// Retired: this page only surfaced the legacy inbound-webhook URL (removed).
export const Route = createFileRoute('/_auth/_side-layout/projects_/details')({
  beforeLoad: () => {
    throw redirect({ to: '/home' as string });
  },
});
